import { PlatformPixelService } from '../../core/platform-payment/platform-pixel.service';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private pixel = inject(PlatformPixelService);
  ngOnInit(): void { this.pixel.init(); }
  title = 'instructor-admin';
}
